module.exports = __webpack_public_path__ + "static/media/leather.fae7d22a.png";